var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"d-block d-md-flex"},[_c('AppAside'),_c('div',{staticClass:"ps-5 page_content grow"},[_c('Table',{ref:"table",on:{"close_form":function($event){return _vm.close_form()},"update_data":function($event){return _vm.get_data()}}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }